// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"86f5ad57","172":"c7f6b03e","368":"746df082","497":"3f476680","641":"f8ed5d26"}[chunkId] + ".chunk.js";
};